import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import { useSelector } from 'react-redux';
import PersonalInfoSummery from "../Signup/PersonalInfoSummery";

import SmiLinkLastDigitCard from "../Signup/SmiLinkLastDigitCard";
import LocateMyCardDetails from "../Signup/LocateMyCardDetails";
import SmiOneRegistrationThroughSSN from "../Signup/SmiOneRegistrationThroughSSN";
import { VALIDATE_SMI_CARD_MOBILE } from "../../../network/URLConstants";
import { retrieveData } from "../../../helpers/utils/Utils";
import { GetApiHeadersWithBearer } from "../../../network/NetworkUtils";
import Cookies from 'js-cookie';
import { PostRequest } from "../../../network/NetworkUtils";
import { STATUS_SUCCESS_CODE } from "../../../network/URLConstants";
import Loader from "../../CustomComponents/Loader";
import ExistingErrorModal from "../Signup/ExistingErrorModal";
import Modal from "../../CustomComponents/Modal";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import SmiLinkThroughSSN from "../Signup/SmiLinkThroughSSN";
import SmiLinkPersonalInfoSummary from "../Signup/SmiLinkPersonalInfoSummary";
import { fetchConfigarationData } from "../../../helpers/utils/Utils";
import { END_SESSION } from "../../../network/URLConstants";
import { createStore } from 'redux';
import rootReducer from '../../../Redux/reducers';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';


const appConfigData = await fetchConfigarationData();
const store = createStore(rootReducer);
export const SmiLinkOnBoard = () => {
  const { t } = useTranslation();

  useDocumentTitle(t('page_title_smione_card_setup'));

  const [activeComponent, setActiveComponent] = useState("smiOneExpirationDate");
  const [personalInfo, setpersonalInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const accessToken = useSelector((state) => state.accessToken);
  const [showValidateSmiMobileErrModal, setShowValidateSmiMobileErrModal] = useState(false)
  const [responseErrorMessage, setResponseErrorMsg] = useState("")
   const dispatch = useDispatch();
  const HeadingStyles =
    "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)]";
  const SubHeadingStyles =
    "w-[90%] md:w-full font-serif-pro modal-title sm:text-[18px] lg:text-[30px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]";
  
console.log("isFromSmiOne", isFromSmiOne)

  const accessTokenToApi = useSelector(state => state.accessToken);
  const isB2c = useSelector(state => state.preferredIdentity);

  const handleLogout = async () => {
    sessionStorage.removeItem('plusModalClosedHome');
    sessionStorage.removeItem('oidc.default');
    global.isLoggedIn = false
    global.accessTokenReload = accessTokenToApi
    logoutManually();
  };

  const logoutManually = async () => {
    if (global.accessTokenReload != '' && global.accessTokenReload != undefined) {
      var url = END_SESSION(isB2c, appConfigData.AUTH_URL, appConfigData.B2C_END_SESSION_URL, appConfigData.CLIENT_ID, global.accessTokenReload, appConfigData.POST_LOGOUT_REDIRECT_URI);
      window.location.replace(url);
      store.dispatch({ type: 'LOGOUT' });
    }
  }
  const closeExistingErrModal = () => {
    setShowValidateSmiMobileErrModal(false);
    window.location.href = "/link-smione-card/Onboard";
  };

  const validatesmiONECardMobile = async (userId) => {
    const bodyRequest = {

    }
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const Url = VALIDATE_SMI_CARD_MOBILE(userId);
    const response = await PostRequest(Url, bodyRequest, headers);
    const responseJson = JSON.parse(response);

    setIsLoading(true)
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {

      setIsLoading(false)
    } else {
      var arrMessages = responseJson.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
      setIsLoading(false)
      setResponseErrorMsg(displayText);
      setShowValidateSmiMobileErrModal(true)
    }
  }

  useEffect(() => {
    // Scroll to the top when the number of cards changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
      const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
      Cookies.remove(kudzuPlusSetForCookies);
       document.body.classList.remove('dark-theme');
        document.body.classList.add('light-theme');
    const userIdCookie = `IdForMigrateUser`;
    const userId = Cookies.get(userIdCookie);
    
    // const migrationLinkTokenCookie = `MigrationTokenCookie`;
    // const token = Cookies.get(migrationLinkTokenCookie);


    // dispatch({ type: 'LINK_USER_ID', payload: userId });
    // dispatch({ type: 'MIGRATION_LINKING_TOKEN', payload: token });
    validatesmiONECardMobile(userId)
  }, [activeComponent]);






  const renderComponent = () => {
    switch (activeComponent) {
      case "smiOneExpirationDate":
        return <SmiLinkLastDigitCard
          handleLastdigitNo={() => { handleSocailSignupClick("smiOneRegistrationThroughSSN") }}
          locateMyCardDetails={() => { handleSocailSignupClick("locateMyCardDetails") }}
        />;

      case "locateMyCardDetails":
        return <LocateMyCardDetails gotItLocateMyCardDetails={() => { handleSocailSignupClick("smiOneExpirationDate") }} />;


      case "smiOneRegistrationThroughSSN":
        return <SmiLinkThroughSSN
          handleSmiOneSSN={() => { handleSocailSignupClick("personalInfoSummary") }}
        />

      case "personalInfoSummary":
         return <SmiLinkPersonalInfoSummary personalInfo={personalInfo}  openPatriotActClick={() => handleSocailSignupClick("patriotAct")}/>


      default:
        return null;
    }
  };


  const getDataFromPersonalInfo = (personalData) => {
    setpersonalInfo(personalData);
  };


  const handleSocailSignupClick = (componentName) => {
    setActiveComponent(componentName);
  };


  const setComponent = (componentName) => {
    setActiveComponent(componentName);
  }


  return (
    <>
      <Layout children={null} LinkSmiOneCard={true}>
        {renderComponent()}
      </Layout>

      {showValidateSmiMobileErrModal && (

        <Modal
          isOpen={showValidateSmiMobileErrModal}
          onClose={handleLogout}
          isLogo={false}
          title={<p className={HeadingStyles}> {t("Oops_smi")} </p>}
          subHeaderMsg={
            <>
              <p className={SubHeadingStyles}>{responseErrorMessage}</p>
            </>
          }
          content={
            <ExistingErrorModal
              onLoginClick={handleLogout}
              hideTryAgain={true}
            //onTryAgainClick={handleTryAgainExistingErr}
            />
          }
        />
      )}
      {isLoading && <Loader />}
    </>
  );
};


export default SmiLinkOnBoard;











